import { createTheme } from "@material-ui/core/styles"
import { Categories } from "app/models/code"
import { docketTheme } from "./docket"

export const baseTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    background: {
      default: docketTheme.colors.background,
    },
    common: {
      black: "#000",
      white: docketTheme.colors.white,
    },
    error: {
      main: "#e72501",
      light: "#ff6235",
      dark: "#ac0000",
      600: "#cf0500", // Error/Hover
    },
    grey: {
      50: docketTheme.colors.grey[95],
      100: docketTheme.colors.grey[90],
      200: docketTheme.colors.grey[80],
      300: docketTheme.colors.grey[70],
      500: "#808080",
      700: "#4d4d4d",
    },
    warning: {
      main: "#ffb723",
      light: "#ffd859",
      dark: "#fd7616",
    },
    primary: {
      main: "#595386",
      dark: "#393055",
      50: "#EBEBF1",
      100: "#CCCDDE",
      200: "#ABADC7",
      300: "#8C8DAF",
      400: "#75739E",
      500: "#605B8F",
      600: "#595386", // main
      700: "#50497A",
      800: "#48406D",
      900: "#393055", // dark
    },
    secondary: {
      main: "#198479",
      light: docketTheme.colors.secondary.light,
      50: "#E0F1F1",
      100: "#B3DDDA",
      200: "#82C8C3",
      300: "#51B2AB",
      400: "#31A198",
      500: "#1B9186",
      600: "#198479",
      700: "#167469",
      800: "#15645A",
      900: "#11483F",
    },
    success: {
      main: docketTheme.colors.success,
      light: "#f4fff3",
    },
    tertiary: {
      main: "#fff464",
      dark: "#e5d83d",
      light: "#fbf38d",
    },
    quaternary: {
      main: "#e3f4f9",
      light: "#d6ebff",
    },
    text: {
      disabled: docketTheme.colors.grey[80],
      hint: "rgba(0, 0, 0, 0.38)",
      primary: docketTheme.colors.body,
      secondary: docketTheme.colors.grey[40],
    },
    absences: {
      [Categories.GeneralLeave]: {
        main: "#8756e6",
        light: "#bc85ff",
        dark: "#5229b3",
      },
      [Categories.Leave]: {
        main: "#e87506",
        light: "#ffa542",
        dark: "#af4700",
      },
      [Categories.Absence]: {
        main: "#a95994",
        light: "#dc88c5",
        dark: "#782b66",
      },
      [Categories.Availability]: {
        main: "#198479",
        light: "#ffa542",
        dark: "#af4700",
      },
    },
    overlay: {
      main: "rgba(0, 0, 0, 0.1)",
    },
  },
  spacing: factor => `${(0.8 * factor).toFixed(1)}rem`,
})
